import { MessageCircle } from "lucide-react";
import { AppointmentChatComposer, AppointmentChatMessageList, useAppointmentChat } from "~/components/appointments/AppointmentChat";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "~/components/ui/dialog";

export type AppointmentChatTarget = {
    appointmentId: string;
    customerName: string;
    appointmentTimeLabel?: string;
};

type AppointmentChatDialogProps = {
    target: AppointmentChatTarget | null;
    onClose: () => void;
};

const AppointmentChatDialog = ({ target, onClose }: AppointmentChatDialogProps) => {
    const open = !!target;
    const { messages, isLoading, send, isSending } = useAppointmentChat(target?.appointmentId ?? '', open);

    return (
        <Dialog open={open} onOpenChange={(isOpen) => { if (!isOpen) onClose(); }}>
            <DialogContent className="sm:max-w-lg flex flex-col gap-4">
                <DialogHeader>
                    <DialogTitle className="flex items-center gap-2">
                        <MessageCircle className="h-5 w-5" />
                        Termin-Chat
                    </DialogTitle>
                    <DialogDescription>
                        {target?.customerName}
                        {target?.appointmentTimeLabel ? ` · ${target.appointmentTimeLabel}` : ''}
                    </DialogDescription>
                </DialogHeader>

                <AppointmentChatMessageList
                    key={target?.appointmentId}
                    messages={messages}
                    isLoading={isLoading}
                    className="h-[50vh] rounded-md border bg-gray-50 p-3"
                />

                <AppointmentChatComposer onSend={send} isSending={isSending} autoFocus />
            </DialogContent>
        </Dialog>
    );
};

export default AppointmentChatDialog;
